import { render } from "./suppliers.vue?vue&type=template&id=7b6c4eec"
import script from "./suppliers.vue?vue&type=script&setup=true&lang=js"
export * from "./suppliers.vue?vue&type=script&setup=true&lang=js"

import "./suppliers.vue?vue&type=style&index=0&id=7b6c4eec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/suppliers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b6c4eec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b6c4eec', __exports__)) {
    api.reload('7b6c4eec', __exports__)
  }
  
  module.hot.accept("./suppliers.vue?vue&type=template&id=7b6c4eec", () => {
    api.rerender('7b6c4eec', render)
  })

}


export default __exports__